import PageHeader from "@/components/PageHeader";
import ValuesBento from "@/components/ValuesBento";
import FounderSection from "@/components/FounderSection";
import CTABand from "@/components/CTABand";
import { COMPANY } from "@/data/site";

export default function About() {
  return (
    <div data-testid="page-about">
      <PageHeader
        overline="About 1st Touch Enterprise Holdings"
        title="An integrated"
        italic="healthcare enterprise."
        description="1TEH was founded to close critical gaps in community-based care — and to do it through a coordinated family of services that treats every patient with dignity, every family with respect, and every team member like the professional they are."
        image="https://images.pexels.com/photos/6129502/pexels-photo-6129502.jpeg"
      />

      <section className="py-24 md:py-32 bg-teh-bg">
        <div className="teh-container">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-5">
              <p className="teh-overline">Our Story</p>
              <h2 className="font-serif text-4xl md:text-5xl mt-4 text-teh-deep leading-tight tracking-tight">
                A Georgia-grown
                <br />
                <span className="italic text-teh-green">healthcare family.</span>
              </h2>
            </div>
            <div className="lg:col-span-7 space-y-6 text-lg text-teh-muted leading-relaxed">
              <p>
                1st Touch Enterprise Holdings, LLC is a Georgia-based,
                minority-owned, woman-owned healthcare management company established
                to improve access to quality healthcare services while addressing
                critical gaps in community-based care.
              </p>
              <p>
                Founded by {COMPANY.founder}, an experienced healthcare executive
                with more than two decades of leadership in administration, sales
                operations, contract management, compliance, and organizational
                development, 1TEH was built around a clear conviction:
                <span className="text-teh-deep font-medium"> coordinated care, delivered with compassion, produces better outcomes.</span>
              </p>
              <p>
                We operate as the parent organization for several healthcare-focused
                divisions — Home Health Care, Non-Emergency Medical Transportation,
                Integrated In-Home Therapy, Durable Medical Equipment, the
                Healthcare Workforce Academy, and Healthcare Management Consulting —
                designed to deliver patient-centered services throughout Georgia and,
                ultimately, across the Southeastern United States.
              </p>
              <p>
                Supporting the organization's community impact is its partner nonprofit,
                Guardian Grace Family & Community Foundation, Inc. — a 501(c)(3) charitable
                organization that works alongside 1TEH to serve caregivers, individuals
                with disabilities, veterans, and underserved populations.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24 bg-teh-surfaceAlt">
        <div className="teh-container grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="bg-white p-10 border-l-4 border-teh-navy">
            <p className="teh-overline">Mission</p>
            <p className="mt-6 font-serif text-2xl md:text-3xl text-teh-deep leading-snug">
              To improve the quality of life for individuals and families by
              delivering compassionate, innovative, and integrated healthcare services
              that promote <span className="italic text-teh-green">independence, dignity, and better health outcomes.</span>
            </p>
          </div>
          <div className="bg-white p-10 border-l-4 border-teh-green">
            <p className="teh-overline">Vision</p>
            <p className="mt-6 font-serif text-2xl md:text-3xl text-teh-deep leading-snug">
              To become one of the Southeast's premier minority-owned healthcare
              organizations by providing <span className="italic text-teh-green">comprehensive healthcare solutions that transform communities</span>, empower caregivers, and improve access to quality care.
            </p>
          </div>
        </div>
      </section>

      <FounderSection />
      <ValuesBento />
      <CTABand />
    </div>
  );
}
